/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Release_Dialog_Ask_UnoInputs */



/**
* | output |
* | --- |
* | "Hey Uno, what's new?" |
*
* @param {Release_Dialog_Ask_UnoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const release_dialog_ask_uno = /** @type {((inputs?: Release_Dialog_Ask_UnoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Release_Dialog_Ask_UnoInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Hey Uno, was ist neu?")
	return /** @type {LocalizedString} */ ("Hey Uno, what's new?")
});